import React from 'react';
import PropTypes from 'prop-types';
import { AlarmEventTreeTable } from './alarm-event/AlarmEventTreeTable';

export const AlarmReportCriteria = ({ summary, children }) => (
  <>
    {children}
    <p><strong>Consists:</strong> {(summary.consists || []).join(', ') || 'All'}</p>
    <p><strong>Cars:</strong> {(summary.cars || []).join(', ') || 'All'}</p>
    <p><strong>Subsystems:</strong> {(summary.subsystems || []).join(', ') || 'All'}</p>
    <p><strong>Event IDs:</strong> {(summary.events || []).join(', ') || 'All'}</p>
    <p className="alarm-report-criteria__wide"><strong>Environment Query:</strong> {summary.environmentQuery || 'None'}</p>
  </>
);

AlarmReportCriteria.propTypes = { summary: PropTypes.object.isRequired, children: PropTypes.node };

export const AlarmReportResults = ({ report, prefix, translate }) => {
  const { result, loading, error, exporting, loaders, runReport, exportCsv, exportExcel } = report;
  const hasResults = !!result && result.occurrenceTotalCount !== 0 && !!result.uniqueConsistList?.length;
  return (
    <div data-testid={`${prefix}-results-container`}>
      {loading && <p className="help-block" data-testid={`${prefix}-loading`}>Loading report results...</p>}
      {error && (
        <div className="text-danger" role="alert" data-testid={`${prefix}-error`}>
          <p>{error}</p>
          <button type="button" className="btn btn-secondary" onClick={runReport} disabled={loading} data-testid={`${prefix}-retry-button`}>
            <i className="fas fa-sync-alt fa-fw" aria-hidden="true" /> Retry
          </button>
        </div>
      )}
      {!loading && !error && !hasResults && <p className="help-block" data-testid={`${prefix}-empty`}>No alarm report results found.</p>}
      {!loading && !error && hasResults && (
        <div data-testid={`${prefix}-results-tree`}>
          <AlarmEventTreeTable alarmEvents={[result]} lazyLoading onLoadOccurrences={loaders.occurrences}
            onLoadOccurrenceEvents={loaders.events} rootLevel="occurrence" toolbarTitle="Report Results"
            isExporting={exporting} isExportDisabled={loading} exportExcelLabel={translate.instant('export.excel')}
            exportCsvLabel={translate.instant('export.csv')} onExportExcel={exportExcel} onExportCsv={exportCsv} />
        </div>
      )}
    </div>
  );
};

AlarmReportResults.propTypes = {
  report: PropTypes.object.isRequired,
  prefix: PropTypes.string.isRequired,
  translate: PropTypes.func.isRequired,
};